(function () {
  // Add body class depending on section for main navigation
  var url = window.location.href;
  var body = document.body;
  if (url.indexOf('/homes') > -1 || window.location.pathname == '/') {
    body.className = 'homes';
  }
  if (url.indexOf('why-meritage') > -1) {
    if (
      url.indexOf('testimonials') > -1 ||
      url.indexOf('energy-efficiency') > -1 ||
      url.indexOf('how-we-design') > -1 ||
      url.indexOf('how-we-build') > -1 ||
      url.indexOf('awards') > -1
    ) {
      body.className = '';
    } else {
      body.className = 'whymeritage';
    }
  }
  if (url.indexOf('buyer-resources') > -1) {
    if (
      url.indexOf('homebuying') > -1 ||
      url.indexOf('financing') > -1 ||
      url.indexOf('energy-efficiency') > -1 ||
      url.indexOf('home-design') > -1 ||
      url.indexOf('design') > -1
    ) {
      body.className = '';
    } else {
      body.className = 'buyerresources';
    }
  }
  if (url.indexOf('my-home') > -1) {
    if (url.indexOf('warranty-claims') > -1) {
      body.className = '';
    } else {
      body.className = 'myhome';
    }
  }

  IE11();

  var topEls = document.querySelectorAll('#main-nav .dropdown--trigger > a');
  topEls.forEach(function (el) {
    var text = el.textContent.trim();
    var sibling = el.nextElementSibling;
    switch (text) {
      case 'Homes':
        sibling.id = 'homes';
        break;
      case 'Why Meritage':
        sibling.id = 'why';
        break;
      case 'Buyer Resources':
        sibling.id = 'resources';
        break;
      case 'My Home':
        sibling.id = 'my-home';
        break;
    }
  });


  var topLinks = $('#main-nav li.dropdown--trigger.nav--menu-item');
  topLinks.on('mouseover', function () {
    $(this).siblings().addClass('hovering');
  });
  topLinks.on('mouseout', function () {
    $(this).siblings().removeClass('hovering');
  });

  // IE11 forEach polyfill
  function IE11() {
    if (typeof NodeList.prototype.forEach !== 'function') {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }
  }
})();


